import $ from 'jquery'

export default {
	name: "tooltip",
	inserted (el, binding) {
		const $el = $(el)
		const template = `<div class="tooltip">${binding.value}</div>`
		var $template, timeout
		$el.hover(function() {
			timeout = setTimeout(function() {
				$template = $(template)
				$template
					.addClass("entering")
					.appendTo($("body"))
					.css({ top: $el.offset().top + $el.height(), left: ($el.offset().left+($el.outerWidth()/2)) - ($template.outerWidth()/2)})
					.removeClass("entering")
			}, 300)
		}, function() {
			if($template && $template.length) {
				$template.remove()
			}
			clearTimeout(timeout)
		})
	}
}



// WEBPACK FOOTER //
// ./src/directives/tooltip.js